import { render, staticRenderFns } from "./selection-2.vue?vue&type=template&id=13e954f0&scoped=true&"
import script from "./selection-2.vue?vue&type=script&lang=js&"
export * from "./selection-2.vue?vue&type=script&lang=js&"
import style0 from "./selection-2.vue?vue&type=style&index=0&id=13e954f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13e954f0",
  null
  
)

export default component.exports